import React from "react";
import "./heroSection.css";
import "../../index.css";
import Button from "../button/button";
import { useState } from "react";
import PopUpModal from "../../popUpForms/formModals/popUpFormModal";
import PopUpFormDownloadScorecard from "../../popUpForms/popUpFormDownloadScorecard";

const HeroScorecardSection = (s) => {
  const [popUpFormVisible, setPopUpFormVisible] = useState(false);
  const [activeForm, setActiveForm] = useState("");

  const handleShowPopUpForm = () => {
    setActiveForm("download");
    setPopUpFormVisible(true);
  };

  return (
    <>
      <div className="scorecard banner-container">
        <div className="bg-image">
          <img
            src="/images/scorecard/scorecard-home-2.webp"
            alt="Scorecard Home"
          />
          <div className="overlay"></div>
        </div>
        <div className="large-screen-limit">
          <div className="hero-content-wrapper">
            <div className="banner-text-right">
              Aldercroft Heights Community Inspection
            </div>
            <div className="scorecard banner-text-left large-screen-limit">
              <div className="overlay">
                <h2 className="banner-top hero-text">
                  Catastrophic Fires Destroy
                </h2>
                <h1 className="hero-text banner-mid">
                  Community Preparation Saves{" "}
                </h1>
                <h4 className="banner-bottom hero-text">
                  Everyone's contribution counts. Together we overcome
                  catastrophe.
                </h4>
                <Button
                  text="Download Scorecard"
                  color="var(--orange)"
                  onClick={handleShowPopUpForm}
                />
              </div>
            </div>
            <div className="scorecard banner-photo-credit-container">
              <p className="banner-credit">Photo credit: C. Brenner</p>
            </div>
          </div>
        </div>
      </div>
      <PopUpModal
        activeForm={"download"}
        formActiveState={popUpFormVisible}
        setFormActiveState={setPopUpFormVisible}
      >
        <PopUpFormDownloadScorecard />
      </PopUpModal>
    </>
  );
};

export default HeroScorecardSection;
